import { supabase } from '../../../infra_/supabase/supabaseClient.js'; 


export async function obtenerCategorias() {
  const { data, error } = await supabase
    .from("productos_categorias")
    .select("*")
    .order("nombre", { ascending: true });

  if (error) {
    console.error("Error al obtener categorias:", error.message);
    return { success: false, error: error.message };
  }

  return { success: true, data };
}
